import { createContext } from 'react'
import { createBrowserHistory } from 'history'

class Router {
  constructor () {
    this.history = createBrowserHistory()
    this.inactiveSession = false
  }

  isCurrentlyOnLoginPage () {
    const loginPages = [
      '/login',
      '/login-sso',
      '/login-act'
    ]
    return loginPages.includes(window.location.pathname)
  }

  isCurrentlyOnPublicPage () {
    const publicPages = [
      // No public pages
    ]
    return this.isCurrentlyOnLoginPage() ||
      publicPages.includes(window.location.pathname)
  }

  redirectToLoginPage (state) {
    state = state || {}
    this.history.push('/login', state)
  }

  getUserHomeRoute () {
    return '/reports'
  }

  getReportListRoute (report) {
    // No parent, go back to list
    if (!report.parent.id) {
      return '/reports'
    }

    // Go back to the parent - only pass the version back if it was passed to the page
    return this.getReportViewRoute(report, { parent: true })
  }

  getReportPageRoute (report, page, { search = false } = {}) {
    let url = `/reports/${report.id}/${page}`
    if (search) {
      url += this.history.location.search
    }
    return url
  }

  getReportViewRoute (report, { parent = false } = {}) {
    const reportId = parent ? report.parent.id : report.id
    const version = this.getQueryParam(parent ? 'parentVersion' : 'version')
    const route = `/reports/${reportId}/view`
    return version ? `${route}?version=${version}` : route
  }

  /**
   * Retrieve the value of the given query parameter
   *
   * @param {string} name Query parameter name to retrieve
   */
  getQueryParam (name) {
    const queryParams = new URLSearchParams(this.history.location.search)
    return queryParams.get(name)
  }

  /**
   * Replace the querystring parameters for current route in the browser history
   *
   * @param {object} params key/value pairs to set in the querystring - an undefined value will delete the parameter
   */
  replaceQueryParams (params) {
    const queryParams = new URLSearchParams(this.history.location.search)
    Object.keys(params).forEach((name) => {
      if (params[name] === undefined) {
        queryParams.delete(name)
      } else {
        queryParams.set(name, params[name])
      }
    })
    this.history.replace({
      pathname: this.history.location.pathname,
      search: `?${queryParams.toString()}`
    })
  }

  setInactiveSession () {
    this.inactiveSession = true
  }
}

export const router = new Router()
export const RouterContext = createContext()
